module.exports = __webpack_public_path__ + "img/icon-warning-landslide-red.c90073be.svg";